// @flow
import * as React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import commentReply from 'app/redux/actions/commentReply';
import api from 'utils/API';
import {getVote, setVote, removeVote, scrollTo} from 'utils/Helper';
import Icon from 'app/components/Icon';
import styles from './CommentActions.styles.js';

type Props = {
  classes: any,
  postId: number,
  commentId: number,
  author: string
};

type State = {
  likes: number,
  inSending: boolean
};

class CommentActions extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    const initData = props.initData || {};

    this.state = {
      likes: initData.likes || 0,
      inSending: false
    };
  }

  send = (postId, commentId, action) => () => {
    const vote = getVote('comment', commentId);
    // user voted before
    if (vote) {
      return;
    }

    // Update vote locally before send to server to prevent duplicate send by user
    const value = action === 'like' ? 1 : -1;
    setVote('comment', commentId, value);
    this.setState({
      [`${action}s`]: Number(this.state[`${action}s`]) + 1
    });
    //

    const url = `/comments/${action}`;
    const data = {
      id: commentId,
      post_id: postId
    };
    api.post(url, data)
    .then(response => {})
    .catch(error => {
      removeVote('comment', commentId, value);
      this.setState({
        [`${action}s`]: Number(this.state[`${action}s`]) - 1
      });
    });
  }

  replyTo = params => () => {
    this.props.dispatch(commentReply.set(params));
    scrollTo('.post-comment-form');
  }

  render() {
    const {classes, postId, commentId} = this.props;
    const likeSelected = getVote('comment', commentId) === 1;
    return (
      <div>
        <span
          className={classNames(classes.item, classes.like, {selected: likeSelected})}
          onClick={this.send(postId, commentId, 'like')}
        >
          <Icon className={classes.itemIcon} name="thumb_up" />
          {this.state.likes}
        </span>
        
        <span
          className={classNames(classes.item, classes.reply)}
          onClick={this.replyTo({commentId, authorName: this.props.author})}
        >
          <Icon className={classes.itemIcon} name="reply" />
        </span>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  commentReply: state.commentReply
});

const Component = connect(mapStateToProps)(withStyles(styles)(CommentActions));
export {Component as CommentActions};
export default Component;